<div class="p-5">
  <div class="no-record-found-container"
  [style.backgroundImage]="backgroundUrl ? 'url(' + backgroundUrl + ')' : 'url(/assets/images/backgrounds/no-data.png)' "
  ></div>
  <div>
    <h2 [ngClass]="{
      'no-record-heading-honeymoon': backgroundUrl,
      'no-record-heading': !backgroundUrl
    }">{{ heading || "No data to show!" }}</h2>
  </div>
</div>
